import { useMutation, useQueryClient } from "react-query";
import { deleteStandard } from "../../../../../actions/Utilities/Standard";
import { toast } from "../../../../../components/toastNotification";

const useDeleteStandard = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => deleteStandard(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetStandard"]);
        toast.fire(
          "Success",
          "Standard were deactivated successfully",
          "success"
        );
      },
      onError: () => {
        toast.fire(
          "Bulk deactivation of Standard failed",
          "Server Error: Cannot deactivate Standard",
          "error"
        );
      },
    }
  );

  return mutate;
};
export default useDeleteStandard;
